import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { customAttributesModel } from '../../company-management/models/customAttributes.model';
import { environment} from '../../../../../environments/environment';
import { companiesModel } from '../../company-management/models/companies.model';
import { Observable } from 'rxjs';
import { UserLocalizationService } from './UserLocalization.service';
import { ApprovalFieldDetailModel } from '../../company-management/models/ApprovalFieldDetail.model';

@Injectable({
  providedIn: 'root'
})
export class CustomAttributesService {

  constructor(private http:HttpClient,private userLocalization:UserLocalizationService) { } 

  add(addData, moduleType, publicFormSubmitterEmail?: string){
    addData.transTimeZone=this.userLocalization.getUserTimeZoneCode();
    
    // Build query parameter if email is provided
    const emailParam = publicFormSubmitterEmail ? `?publicFormSubmitterEmail=${encodeURIComponent(publicFormSubmitterEmail)}` : '';
    
    switch (moduleType){
      case 1:{        
        return this.http.post(environment.baseUrl + '/transactions/api/contact/addEditContact' + emailParam, addData);
        //break;
      }
      case 2:{
        return this.http.post(environment.baseUrl + '/transactions/api/company/addEditCompany' + emailParam, addData);
        //break;
      }
      case 3:{
        return this.http.post(environment.baseUrl + '/transactions/api/opportunity/addEditOpportunity' + emailParam, addData);
        //break;
      }
      case 4:{
        addData.userTime=this.userLocalization.getUserTime();
        return this.http.post(environment.baseUrl + '/transactions/api/product/addEditProduct' + emailParam, addData);
        //break;
      }
      default: { 
        return this.http.post(environment.baseUrl + '/transactions/api/activities/addEditActivity' + emailParam, addData);
        //break;
     } 
    }

  }

  getFields(moduleType, projectId: number){
    return this.http.get<companiesModel>(environment.baseUrl + '/transactions/api/customType/getFields?projectId='+projectId+'&moduleType='+moduleType)
  }

  getLinkedDataListDetails(moduleType, projectId: number){
    return this.http.get(environment.baseUrl + '/transactions/api/customType/getLinkedDataList?projectId='+projectId+'&moduleType='+moduleType)
  }

  getFieldRelation(attributeId,attributeLookupId){
    return this.http.get<companiesModel>(environment.baseUrl + '/setting/api/customType/getChildAttributes?attributeId='+attributeId+'&attributeLookupId='+attributeLookupId)
  }

  getParticularCompany(id,moduleType, projectId: number, callMongoAPI = false){

    if(moduleType==1){
      return this.http.get<companiesModel[]>(
        environment.baseUrl + '/transactions/api/contact/getContact?projectId='+projectId+'&contactId='+id);
    }
    if(moduleType==2){
      if(callMongoAPI){
      return this.http.get<companiesModel[]>(
        environment.baseUrl + '/mongotransactions/api/company/getCompany?projectId='+projectId+'&companyId='+id);
      }
      else{
        return this.http.get<companiesModel[]>(
          environment.baseUrl + '/transactions/api/company/getCompany?projectId='+projectId+'&companyId='+id);
      }
    
    }
    if(moduleType==3){
      return this.http.get<companiesModel[]>(
        environment.baseUrl + '/transactions/api/opportunity/getOpportunity?projectId='+projectId+'&opportunityId='+id);
      
    }
    if(moduleType==4){
      return this.http.get<companiesModel[]>(
        environment.baseUrl + '/transactions/api/product/getProduct?projectId='+projectId+'&productId='+id);
      
    }
    else{
      return this.http.get<companiesModel[]>(
        environment.baseUrl + '/transactions/api/activities/getActivity?projectId='+projectId+'&activityId='+id);
      
    }


    // switch (moduleType){
    //   case 1:{        
    //     return this.http.get<companiesModel[]>(
    //       environment.baseUrl + '/transactions/api/contact/getContact?projectId='+projectId+'&contactId='+id);
    //     break;
    //   }
    //   case 2:{
    //     return this.http.get<companiesModel[]>(
    //       environment.baseUrl + '/transactions/api/company/getCompany?projectId='+projectId+'&companyId='+id);
    //     break;
    //   }
    //   case 3:{
    //     return this.http.get<companiesModel[]>(
    //       environment.baseUrl + '/transactions/api/opportunity/getOpportunity?projectId='+projectId+'&opportunityId='+id);
    //     break;
    //   }
    //   case 4:{
    //     return this.http.get<companiesModel[]>(
    //       environment.baseUrl + '/transactions/api/product/getProduct?projectId='+projectId+'&productId='+id);
    //     break;
    //   }      
    //   default: { 
    //     console.log("No such module exists!");
    //     break; 
    //  } 
    // }
   
  }

  getAllCustomAttributes(module, projectId: number){
    return this.http.post<customAttributesModel[]>(
      environment.baseUrl + '/setting/api/customType/getAllCustomAttributes',{
      "projectId": projectId,
      "moduleType": module
    })
  }

  getCompanyTypeCustomAttributes(companyTypeId, projectId: number){
    return this.http.post<customAttributesModel[]>(
      environment.baseUrl + '/transactions/api/company/getCompanyTypeCustomAttributes',{
      "companyTypeId": companyTypeId,
      "projectId": projectId
    })
  }

  getOpportunityTypeCustomAttributes(opportunityTypeId, projectId: number){
    return this.http.post<customAttributesModel[]>(
      environment.baseUrl + '/transactions/api/opportunity/getOpportunityTypeCustomAttributes',{
      "opportunityTypeId": opportunityTypeId,
      "projectId": projectId
    })
  }

  getContactTypeCustomAttributes(contactTypeId, projectId: number){
    return this.http.post<customAttributesModel[]>(
      environment.baseUrl + '/transactions/api/contact/getContactTypeCustomAttributes',{
      "contactTypeId": contactTypeId,
      "projectId": projectId
    })
  }
  
  getActivityLookup(moduleType, projectId: number, companyId, opportunityId){

    if(opportunityId!=null){
     
      return this.http.get<customAttributesModel[]>(
        environment.baseUrl + '/transactions/api/activities/getActivityLookup?projectId='+projectId+'&moduleType='+moduleType+'&companyId='+companyId+'&opportunityId='+opportunityId)
   
    }else{
     
    return this.http.get<customAttributesModel[]>(
      environment.baseUrl + '/transactions/api/activities/getActivityLookup?projectId='+projectId+'&moduleType='+moduleType+'&companyId='+companyId)
    }
    }

  getActivity(activityId, projectId: number){
    return this.http.get<customAttributesModel[]>(
      environment.baseUrl + '/transactions/api/activities/getActivity?projectId='+projectId+'&activityId='+activityId)
  }

  getOwner(projectId: number,moduleId:number){
    return this.http.get<customAttributesModel[]>(
     // environment.baseUrl + '/login/api/users/downHierarchy?projectId='+projectId);
     environment.baseUrl + '/login/api/users/fetchModuleOwnerOptions?projectId='+projectId+'&moduleId='+moduleId);
  }

  mapOpportunityContact(contactId, opportunityId, projectId){
    return this.http.get<customAttributesModel[]>(
      // environment.baseUrl + '/login/api/users/downHierarchy?projectId='+projectId);
      environment.baseUrl + '/reports/api/opportunity/dashboard/updateContactMapping?projectId='+projectId+'&opportunityId='+opportunityId+'&contactId='+contactId);
  }

  fetchApprovalFieldDetails(projectId,moduleType,approvalId){
    return this.http.get<ApprovalFieldDetailModel[]>(
      environment.baseUrl + '/transactions/api/workflows/approval/fetchApprovalFieldDetail?projectId='+projectId+'&moduleType='+moduleType+'&approvalId='+approvalId);
  }

  addEditFieldVisibilitySettings(requestData) {
    return this.http.post(environment.baseUrl + '/setting/api/fields/addEditFieldVisibilitySettings', requestData);
  }

  getActivitySerialNo(projectId, moduleType){
    return this.http.get(
      environment.baseUrl + '/transactions/api/activities/getActivitySerialNo?projectId='+projectId+'&moduleType='+moduleType)
  }

  getproductFormRecord(activityId: number, projectId: number, productFormId: number) {
    return this.http.get(
      `${environment.baseUrl}/transactions/api/activities/getProductFormRecord/v2?activityId=${activityId}&projectId=${projectId}&productFormId=${productFormId}`)
  }
}
